import React from 'react';

import { ComponentPreview } from '@paragon/client-tools';
import { getClientUrls } from '@paragon/login-tools';

import { getMemberVertices } from '../../selectors/componentGeometry';
import { useAppSelector } from '../hooks';

interface Props {
  readonly analysisSetGuid: string;
  readonly maxWidth: number;
  readonly maxHeight: number;
}

export function ComponentPreviewCell({ analysisSetGuid, maxWidth, maxHeight }: Props) {
  const componentDesignsWithInformationByAnalysisSetGuid = useAppSelector(
    (state) => state.componentDesignsWithInformationByAnalysisSetGuid,
  );
  const componentDesignWithInformation = componentDesignsWithInformationByAnalysisSetGuid[analysisSetGuid];
  const componentDesignGuid =
    typeof componentDesignWithInformation === 'object' ? componentDesignWithInformation.componentDesign.guid : null;
  const designUrlForEnvironment = useAppSelector(getClientUrls).designUrl;
  const memberVertices = useAppSelector((state) => getMemberVertices(state, analysisSetGuid));

  if (!componentDesignGuid || !memberVertices) return null;

  return (
    <ComponentPreview
      memberVertices={memberVertices}
      url={`${designUrlForEnvironment}0/${componentDesignGuid}/componentDesign/${componentDesignGuid}/0?analysisSetGuid=${analysisSetGuid}`}
      maxWidth={maxWidth}
      maxHeight={maxHeight}
    />
  );
}
